(function () {

    class PlugListbox extends HTMLElement {
        constructor() {
            super();

            this.elements = {};
            this.elements.btn = this.getElementsByClassName("listbox-btn")[0];
            this.elements.carat = this.elements.btn.getElementsByTagName("svg")[0];
            this.elements.activeValue = this.getElementsByClassName("listbox-value")[0];
            this.elements.list = this.getElementsByClassName("listbox-list")[0];
            this.elements.options = Array.from(this.elements.list.getElementsByTagName("li"));

            this.emptyValue = this.dataset.emptyValue;
            this.showTransitionDuration = 200;
            this.onChangeCallbacks = [];

            this.setupListeners();
        }

        setupListeners() {
            this.elements.btn.addEventListener("click", () => {
                return (
                    this.classList.contains("is-open")
                    ? this.hide()
                    : this.show()
                );
            }, false);


            this.elements.options.forEach((option, index) => {
                option.addEventListener("click", () => {
                    this.hide();
                    if (option.getAttribute("aria-selected") !== "true") {
                        this.elements.activeValue.textContent = option.textContent;
                        if (this.elements.activeValue.textContent === this.emptyValue) {
                            this.classList.add("is-empty");
                        } else {
                            this.classList.remove("is-empty");
                        }
                        this.elements.options.forEach((option, j) => {
                            if (index === j) {
                                option.setAttribute("aria-selected", "true");
                            } else {
                                option.removeAttribute("aria-selected");
                            }
                        });
                        this.onChangeCallbacks.forEach(cb => cb(option, this));
                    }
                }, false);
            });

            let hideTimer;

            this.elements.btn.addEventListener("blur", () => {
                hideTimer = setTimeout(() => { this.hide(); }, 100);
            });

            this.elements.list.addEventListener("focus", () => {
                clearTimeout(hideTimer);
            });
        }

        onChange(cb) {
            this.onChangeCallbacks.push(cb);
        }

        show() {
            this.classList.add("is-open");
            this.elements.carat.classList.add("is-rotated");
            requestAnimationFrame(() => {
                this.elements.list.classList.add("is-showing");
            });
        }

        hide() {
            this.elements.carat.classList.remove("is-rotated");
            this.elements.list.classList.remove("is-showing");
            setTimeout(() => {
                this.classList.remove("is-open");
            }, this.showTransitionDuration);
        }

        getValue() {
            return (
                this.elements.activeValue.textContent !== this.emptyValue
                ? this.elements.activeValue.textContent
                : undefined
            );
        }

        setValue(value) {
            const options = this.elements.options;
            const option = options.find(option => (
                option.dataset.value === value
                || option.textContent === value
            ));

            if (option && option.getAttribute("aria-selected") !== "true") {
                const optionIndex = options.indexOf(option);
                this.elements.activeValue.textContent = option.textContent;
                if (this.elements.activeValue.textContent === this.emptyValue) {
                    this.classList.add("is-empty");
                } else {
                    this.classList.remove("is-empty");
                }
                options.forEach((option, j) => {
                    if (optionIndex === j) {
                        option.setAttribute("aria-selected", "true");
                    } else {
                        option.removeAttribute("aria-selected");
                    }
                });
            }
        }
    }
    customElements.define("plug-listbox", PlugListbox);

    window.addEventListener("DOMContentLoaded", init);

    function init() {
        // Set up localization forms.
        const forms = [
            document.getElementById("DesktopHeaderLanguageForm"),
            document.getElementById("MobileHeaderLanguageForm")
        ];
        forms.forEach(form => setupLanguageForm(form));
    }

    function setupLanguageForm(form) {
        const listbox = form.getElementsByTagName("plug-listbox")[0];
        const hiddenInput = form.querySelector("[name='locale_code']");
        listbox.onChange(option => {
            hiddenInput.value = option.dataset.isoCode;
            form.submit();
        });
    }

})();
